var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"292px"},attrs:{"src":require("@assets/kefu.png"),"alt":"logo"}})])
}]

export { render, staticRenderFns }